import { createSlice } from "@reduxjs/toolkit";

const commandsSlice = createSlice({
  name: "commands",
  initialState: { currentCommands: [] },
  reducers: {
    update(state, action) {
      state.currentCommands = action.payload;
    },
  },
});

export const commandsActions = commandsSlice.actions;

export default commandsSlice;
